import { useEffect } from 'react';
import localStorageService from '../../../../services/localStorageService';

const Logout = ({ history }) => {
  useEffect(() => {
    localStorageService.removeJWT();
    history.replace('/');
  }, [history]);

  return null;
};

export default Logout;
